import { InnerBlocks } from '@wordpress/block-editor';
import { useEffect } from '@wordpress/element';

import Settings from './Settings';
import Style from './Style';

const Edit = props => {
	const { className, attributes, setAttributes, clientId } = props;

	useEffect(() => { clientId && setAttributes({ cId: clientId.substring(0, 10) }); }, [clientId]); // Set & Update clientId to cId

	return <>
		<Settings attributes={props.attributes} setAttributes={setAttributes} />

		<div className={className} id={`smbStickyMenu-${clientId}`}>
			<Style attributes={attributes} clientId={clientId} />

			<div className='smbStickyMenu'>
				<InnerBlocks template={[
					['core/paragraph', {
						content: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Repellat, enim. Magni quis et voluptas voluptatum facere saepe cum reiciendis assumenda eveniet rem.',
						align: 'center',
						style: {
							typography: { fontSize: '20px' },
							color: { text: '#fff' }
						}
					}]
				]} />
			</div>
		</div>
	</>;
};
export default Edit;